// extracted by mini-css-extract-plugin
export default {"body":"LandingHow1_body__KDNJu","image":"LandingHow1_image__RRKBF","inputs":"LandingHow1_inputs__u2osi"};